import moment from "moment";

export function formatRelativeDate(isoString) {
  const date = moment(isoString);
  const now = moment();

  const diffDays = now.diff(date, "days");
  const isToday = date.day() === now.day();
  const isYesterday = diffDays <= 1 && date.day() !== now.day();

  if (isToday) {
    return `Today at ${date.format("HH:mm")}`;
  }

  if (isYesterday) {
    return `Yesterday at ${date.format("HH:mm")}`;
  }

  if (diffDays > 0 && diffDays < 30) {
    return `${diffDays} days ago`;
  }

  return date.format("DD.MM.YYYY HH:mm:ss");
}
